import React from 'react';
import VideoModalS2 from '../ModalVideoS2/ModalVideoS2';

// import VideoBg from '../../images/wpo-video-bg.jpg';

const VideoSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <h2 className="d-none">itit</h2>
            <div className="wraper" style={{ backgroundImage: `url(${`https://res.cloudinary.com/dexvxngzg/image/upload/v1764569433/wpo-video-bg.02a9494ee3d83704a846_r8aohf.jpg`})`}} >
                <div className="video-wrap">
                    <div className="video-holder">
                        <VideoModalS2 />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoSection;
